// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: linear-gradient(135deg, #fff6d6 0%, #fffbea 50%, #ffffff 100%);
  position: relative;
  overflow: hidden;
}

.login-page::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 800px;
  height: 800px;
  background: radial-gradient(circle, rgba(247, 189, 32, 0.15) 0%, transparent 70%);
  border-radius: 50%;
  animation: float 20s ease-in-out infinite;
}

.login-page::after {
  content: '';
  position: absolute;
  bottom: -30%;
  left: -10%;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(255, 193, 7, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  animation: float 15s ease-in-out infinite reverse;
}

@keyframes float {

  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }

  50% {
    transform: translate(50px, 50px) scale(1.1);
  }
}

@keyframes shake {

  0%,
  100% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(-5px);
  }

  50% {
    transform: translateX(5px);
  }

  75% {
    transform: translateX(-5px);
  }
}

.login-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  max-width: 1000px;
  width: 100%;
  background: rgba(255, 255, 255, 0.95);
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
  border-radius: 32px;
  box-shadow: 0 40px 120px rgba(17, 17, 17, 0.15);
  overflow: hidden;
  position: relative;
  z-index: 1;
  border: 1px solid rgba(247, 189, 32, 0.2);
}

/* Left Section - Form */
.login-form-section {
  padding: 1rem 3rem 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 550px;
}

.login-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: -1rem;
  margin-bottom: 0rem;
  text-decoration: none;
}

.login-logo img {
  height: 140px;
  width: auto;
  object-fit: contain;
  filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.08));
  transition: transform 0.3s ease;
}

.login-logo img:hover {
  transform: scale(1.02);
}

.login-content {
  flex: 1 1;
  text-align: center;
}

.login-content h1 {
  font-size: 1.8rem;
  margin: 0 0 0.5rem;
  color: var(--secondary);
  font-weight: 800;
  line-height: 1.2;
}

.login-subtitle {
  color: var(--text-muted);
  font-size: 0.95rem;
  margin: 0 auto 1.5rem;
  line-height: 1.6;
  max-width: 450px;
}

/* Login Method Tabs */
.login-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0.75rem;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  background: rgba(247, 189, 32, 0.08);
  padding: 0.35rem;
  border-radius: 16px;
  border: 1px solid rgba(247, 189, 32, 0.15);
}

.tab-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.7rem 1.2rem;
  border: none;
  background: transparent;
  color: var(--text-muted);
  font-size: 1rem;
  font-weight: 600;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.tab-btn svg {
  width: 18px;
  height: 18px;
  transition: all 0.3s ease;
}

.tab-btn:hover:not(.active) {
  color: var(--primary);
  background: rgba(247, 189, 32, 0.1);
}

.tab-btn.active {
  background: linear-gradient(135deg, #f7bd20, #f5a623);
  color: #1a1a1a;
  font-weight: 700;
  box-shadow: 0 10px 30px rgba(247, 189, 32, 0.3),
    0 2px 8px rgba(247, 189, 32, 0.2);
}

.tab-btn.active svg {
  transform: scale(1.1);
}

/* Forms */
.auth-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-weight: 600;
  color: var(--secondary);
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* Regular Input Fields */
.form-group input[type="text"],
.form-group input[type="tel"],
.form-group input[type="email"] {
  width: 100%;
  padding: 0.8rem 1rem;
  border: 2px solid rgba(247, 189, 32, 0.2);
  border-radius: 14px;
  font-size: 1rem;
  font-weight: 500;
  background: var(--surface-soft);
  transition: all 0.3s ease;
  outline: none;
  font-family: inherit;
}

.form-group input[type="text"]:focus,
.form-group input[type="tel"]:focus,
.form-group input[type="email"]:focus {
  border-color: var(--primary);
  background: #fff;
  box-shadow: 0 0 0 4px rgba(247, 189, 32, 0.1);
}

.form-group input::placeholder {
  color: var(--text-muted);
  opacity: 0.6;
}

/* Phone Input with Prefix */
.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background: var(--surface-soft);
  border: 2px solid rgba(247, 189, 32, 0.2);
  border-radius: 14px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.input-wrapper:focus-within {
  border-color: var(--primary);
  background: #fff;
  box-shadow: 0 0 0 4px rgba(247, 189, 32, 0.1);
}

.input-prefix {
  padding: 0 1rem;
  font-weight: 700;
  color: #1a1a1a;
  border-right: 2px solid rgba(247, 189, 32, 0.15);
  background: rgba(247, 189, 32, 0.12);
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 1rem;
}

.input-wrapper input {
  flex: 1 1;
  border: none;
  outline: none;
  padding: 0.8rem 1rem;
  font-size: 1rem;
  background: transparent;
  font-family: inherit;
  font-weight: 500;
}

.input-wrapper input::placeholder {
  color: var(--text-muted);
  opacity: 0.6;
}

/* Password Input with Toggle */
.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-wrapper input {
  width: 100%;
  padding: 0.8rem 3rem 0.8rem 1rem;
  border: 2px solid rgba(247, 189, 32, 0.2);
  border-radius: 14px;
  font-size: 1rem;
  font-weight: 500;
  background: var(--surface-soft);
  transition: all 0.3s ease;
  outline: none;
  font-family: inherit;
}

.password-input-wrapper input:focus {
  border-color: var(--primary);
  background: #fff;
  box-shadow: 0 0 0 4px rgba(247, 189, 32, 0.1);
}

.toggle-password {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  transition: all 0.3s ease;
  border-radius: 8px;
}

.toggle-password:hover {
  background: rgba(247, 189, 32, 0.1);
  color: var(--primary);
}

.toggle-password svg {
  width: 20px;
  height: 20px;
}

.forgot-password-link {
  align-self: flex-end;
  color: var(--primary);
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  margin-top: -0.25rem;
}

.forgot-password-link:hover {
  text-decoration: underline;
  color: var(--primary-dark);
}

/* OTP Inputs */
.otp-inputs {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 0.75rem;
  gap: 0.75rem;
}

.otp-inputs input {
  width: 100%;
  aspect-ratio: 1;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;
  border: 2px solid rgba(247, 189, 32, 0.2);
  border-radius: 12px;
  background: var(--surface-soft);
  outline: none;
  transition: all 0.3s ease;
  color: var(--secondary);
}

.otp-inputs input:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 4px rgba(247, 189, 32, 0.1);
  background: #fff;
  transform: scale(1.05);
}

.resend-btn {
  background: none;
  border: none;
  color: var(--primary);
  font-weight: 600;
  cursor: pointer;
  padding: 0.5rem 0;
  text-align: right;
  font-size: 0.9rem;
  transition: color 0.3s ease;
  margin-top: 0.5rem;
}

.resend-btn:hover {
  color: var(--primary-dark);
  text-decoration: underline;
}

.otp-footer {
  margin-top: 1rem;
  text-align: center;
  min-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.timer-text {
  color: var(--text-muted);
  font-size: 0.95rem;
  font-weight: 500;
  margin: 0;
}

.timer-text span {
  color: var(--primary);
  font-weight: 700;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  margin-left: 4px;
}

/* Checkbox */
.form-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.5rem 0;
}

.form-checkbox input[type="checkbox"] {
  margin-top: 0.25rem;
  width: 20px;
  height: 20px;
  accent-color: var(--primary);
  cursor: pointer;
  border-radius: 6px;
}

.form-checkbox label {
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.5;
  cursor: pointer;
}

.form-checkbox a {
  color: var(--primary);
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
}

.form-checkbox a:hover {
  text-decoration: underline;
  color: var(--primary-dark);
}

/* Submit Button */
.submit-btn {
  background: linear-gradient(135deg, #f7bd20, #f5a623);
  color: #1a1a1a;
  border: none;
  border-radius: 14px;
  padding: 0.9rem 1.5rem;
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 10px 30px rgba(247, 189, 32, 0.3),
    0 2px 8px rgba(247, 189, 32, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 15px 40px rgba(247, 189, 32, 0.4),
    0 5px 15px rgba(247, 189, 32, 0.2);
}

.submit-btn:active:not(:disabled) {
  transform: translateY(0);
}

.submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(26, 26, 26, 0.3);
  border-top-color: #1a1a1a;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.change-number-btn {
  background: transparent;
  border: 2px solid rgba(247, 189, 32, 0.3);
  color: var(--primary);
  border-radius: 14px;
  padding: 0.9rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.change-number-btn:hover {
  background: rgba(247, 189, 32, 0.1);
  border-color: var(--primary);
  transform: translateY(-1px);
}

/* Footer */
.login-footer {
  text-align: center;
  color: var(--text-muted);
  font-size: 0.95rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(247, 189, 32, 0.1);
}

.login-footer a {
  color: var(--primary);
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
}

.login-footer a:hover {
  text-decoration: underline;
  color: var(--primary-dark);
}

/* Right Section - Visual */
/* Carousel Styles */
.login-visual-section {
  flex: 1 1;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: #000;
  padding: 0;
}

.carousel-track {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 0;
  transition: opacity 1s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 40px;
  z-index: 1;
}

.carousel-slide.active {
  opacity: 1;
  z-index: 2;
}

.slide-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.2) 50%, rgba(0, 0, 0, 0.1) 100%);
  z-index: -1;
}

.slide-content {
  color: #fff;
  z-index: 3;
  animation: slideUp 0.8s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.slide-content h2 {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 12px;
  line-height: 1.2;
}

.slide-content p {
  font-size: 14px;
  opacity: 0.9;
  line-height: 1.6;
  max-width: 80%;
}

.carousel-indicators {
  position: absolute;
  bottom: 30px;
  right: 30px;
  display: flex;
  gap: 8px;
  z-index: 10;
}

.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicator.active {
  background: #fff;
  width: 30px;
  border-radius: 10px;
}


/* Responsive */
@media (max-width: 968px) {
  .login-container {
    grid-template-columns: 1fr;
  }

  .login-visual-section {
    display: none;
  }

  .login-logo img {
    height: 140px;
  }

  .login-form-section {
    min-height: auto;
    padding: 1.5rem 1.75rem;
  }
}

@media (max-width: 640px) {
  .login-page {
    padding: 1rem;
  }

  .login-form-section {
    padding: 2rem 1.5rem;
  }

  .login-content h1 {
    font-size: 2rem;
  }

  .login-tabs {
    gap: 0.5rem;
  }

  .tab-btn {
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
  }

  .tab-btn svg {
    width: 16px;
    height: 16px;
  }

  .otp-inputs {
    gap: 0.5rem;
  }

  .otp-inputs input {
    font-size: 1.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0EAA0E;EAC1E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iFAAiF;EACjF,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,+EAA+E;EAC/E,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;;EAEE;;IAEE,mCAAmC;EACrC;;EAEA;IACE,2CAA2C;EAC7C;AACF;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,WAAW;EACX,qCAAqC;EACrC,mCAA2B;UAA3B,2BAA2B;EAC3B,mBAAmB;EACnB,+CAA+C;EAC/C,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,yCAAyC;AAC3C;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,oDAAoD;EACpD,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAY;EAAZ,YAAY;EACZ,qBAAqB;EACrB,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,gBAAgB;EAChB;qCACmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA,yBAAyB;AACzB;;;EAGE,WAAW;EACX,oBAAoB;EACpB,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,aAAa;EACb,oBAAoB;AACtB;;AAEA;;;EAGE,4BAA4B;EAC5B,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gDAAgD;EAChD,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,6CAA6C;EAC7C,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,6BAAkC;EAAlC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD;sCACoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B;sCACoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;EACzC,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B,oBAAoB;AACpB;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,UAAU;EACV,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2GAA2G;EAC3G,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;;AAGA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".login-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: linear-gradient(135deg, #fff6d6 0%, #fffbea 50%, #ffffff 100%);\n  position: relative;\n  overflow: hidden;\n}\n\n.login-page::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  right: -20%;\n  width: 800px;\n  height: 800px;\n  background: radial-gradient(circle, rgba(247, 189, 32, 0.15) 0%, transparent 70%);\n  border-radius: 50%;\n  animation: float 20s ease-in-out infinite;\n}\n\n.login-page::after {\n  content: '';\n  position: absolute;\n  bottom: -30%;\n  left: -10%;\n  width: 600px;\n  height: 600px;\n  background: radial-gradient(circle, rgba(255, 193, 7, 0.1) 0%, transparent 70%);\n  border-radius: 50%;\n  animation: float 15s ease-in-out infinite reverse;\n}\n\n@keyframes float {\n\n  0%,\n  100% {\n    transform: translate(0, 0) scale(1);\n  }\n\n  50% {\n    transform: translate(50px, 50px) scale(1.1);\n  }\n}\n\n@keyframes shake {\n\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n\n  25% {\n    transform: translateX(-5px);\n  }\n\n  50% {\n    transform: translateX(5px);\n  }\n\n  75% {\n    transform: translateX(-5px);\n  }\n}\n\n.login-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  max-width: 1000px;\n  width: 100%;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 32px;\n  box-shadow: 0 40px 120px rgba(17, 17, 17, 0.15);\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n  border: 1px solid rgba(247, 189, 32, 0.2);\n}\n\n/* Left Section - Form */\n.login-form-section {\n  padding: 1rem 3rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-height: 550px;\n}\n\n.login-logo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: -1rem;\n  margin-bottom: 0rem;\n  text-decoration: none;\n}\n\n.login-logo img {\n  height: 140px;\n  width: auto;\n  object-fit: contain;\n  filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.08));\n  transition: transform 0.3s ease;\n}\n\n.login-logo img:hover {\n  transform: scale(1.02);\n}\n\n.login-content {\n  flex: 1;\n  text-align: center;\n}\n\n.login-content h1 {\n  font-size: 1.8rem;\n  margin: 0 0 0.5rem;\n  color: var(--secondary);\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.login-subtitle {\n  color: var(--text-muted);\n  font-size: 0.95rem;\n  margin: 0 auto 1.5rem;\n  line-height: 1.6;\n  max-width: 450px;\n}\n\n/* Login Method Tabs */\n.login-tabs {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n  background: rgba(247, 189, 32, 0.08);\n  padding: 0.35rem;\n  border-radius: 16px;\n  border: 1px solid rgba(247, 189, 32, 0.15);\n}\n\n.tab-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.7rem 1.2rem;\n  border: none;\n  background: transparent;\n  color: var(--text-muted);\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n}\n\n.tab-btn svg {\n  width: 18px;\n  height: 18px;\n  transition: all 0.3s ease;\n}\n\n.tab-btn:hover:not(.active) {\n  color: var(--primary);\n  background: rgba(247, 189, 32, 0.1);\n}\n\n.tab-btn.active {\n  background: linear-gradient(135deg, #f7bd20, #f5a623);\n  color: #1a1a1a;\n  font-weight: 700;\n  box-shadow: 0 10px 30px rgba(247, 189, 32, 0.3),\n    0 2px 8px rgba(247, 189, 32, 0.2);\n}\n\n.tab-btn.active svg {\n  transform: scale(1.1);\n}\n\n/* Forms */\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.form-group label {\n  font-weight: 600;\n  color: var(--secondary);\n  font-size: 0.95rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n/* Regular Input Fields */\n.form-group input[type=\"text\"],\n.form-group input[type=\"tel\"],\n.form-group input[type=\"email\"] {\n  width: 100%;\n  padding: 0.8rem 1rem;\n  border: 2px solid rgba(247, 189, 32, 0.2);\n  border-radius: 14px;\n  font-size: 1rem;\n  font-weight: 500;\n  background: var(--surface-soft);\n  transition: all 0.3s ease;\n  outline: none;\n  font-family: inherit;\n}\n\n.form-group input[type=\"text\"]:focus,\n.form-group input[type=\"tel\"]:focus,\n.form-group input[type=\"email\"]:focus {\n  border-color: var(--primary);\n  background: #fff;\n  box-shadow: 0 0 0 4px rgba(247, 189, 32, 0.1);\n}\n\n.form-group input::placeholder {\n  color: var(--text-muted);\n  opacity: 0.6;\n}\n\n/* Phone Input with Prefix */\n.input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background: var(--surface-soft);\n  border: 2px solid rgba(247, 189, 32, 0.2);\n  border-radius: 14px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.input-wrapper:focus-within {\n  border-color: var(--primary);\n  background: #fff;\n  box-shadow: 0 0 0 4px rgba(247, 189, 32, 0.1);\n}\n\n.input-prefix {\n  padding: 0 1rem;\n  font-weight: 700;\n  color: #1a1a1a;\n  border-right: 2px solid rgba(247, 189, 32, 0.15);\n  background: rgba(247, 189, 32, 0.12);\n  height: 100%;\n  display: flex;\n  align-items: center;\n  font-size: 1rem;\n}\n\n.input-wrapper input {\n  flex: 1;\n  border: none;\n  outline: none;\n  padding: 0.8rem 1rem;\n  font-size: 1rem;\n  background: transparent;\n  font-family: inherit;\n  font-weight: 500;\n}\n\n.input-wrapper input::placeholder {\n  color: var(--text-muted);\n  opacity: 0.6;\n}\n\n/* Password Input with Toggle */\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-wrapper input {\n  width: 100%;\n  padding: 0.8rem 3rem 0.8rem 1rem;\n  border: 2px solid rgba(247, 189, 32, 0.2);\n  border-radius: 14px;\n  font-size: 1rem;\n  font-weight: 500;\n  background: var(--surface-soft);\n  transition: all 0.3s ease;\n  outline: none;\n  font-family: inherit;\n}\n\n.password-input-wrapper input:focus {\n  border-color: var(--primary);\n  background: #fff;\n  box-shadow: 0 0 0 4px rgba(247, 189, 32, 0.1);\n}\n\n.toggle-password {\n  position: absolute;\n  right: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n  transition: all 0.3s ease;\n  border-radius: 8px;\n}\n\n.toggle-password:hover {\n  background: rgba(247, 189, 32, 0.1);\n  color: var(--primary);\n}\n\n.toggle-password svg {\n  width: 20px;\n  height: 20px;\n}\n\n.forgot-password-link {\n  align-self: flex-end;\n  color: var(--primary);\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  margin-top: -0.25rem;\n}\n\n.forgot-password-link:hover {\n  text-decoration: underline;\n  color: var(--primary-dark);\n}\n\n/* OTP Inputs */\n.otp-inputs {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 0.75rem;\n}\n\n.otp-inputs input {\n  width: 100%;\n  aspect-ratio: 1;\n  text-align: center;\n  font-size: 1.5rem;\n  font-weight: 700;\n  border: 2px solid rgba(247, 189, 32, 0.2);\n  border-radius: 12px;\n  background: var(--surface-soft);\n  outline: none;\n  transition: all 0.3s ease;\n  color: var(--secondary);\n}\n\n.otp-inputs input:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 4px rgba(247, 189, 32, 0.1);\n  background: #fff;\n  transform: scale(1.05);\n}\n\n.resend-btn {\n  background: none;\n  border: none;\n  color: var(--primary);\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0.5rem 0;\n  text-align: right;\n  font-size: 0.9rem;\n  transition: color 0.3s ease;\n  margin-top: 0.5rem;\n}\n\n.resend-btn:hover {\n  color: var(--primary-dark);\n  text-decoration: underline;\n}\n\n.otp-footer {\n  margin-top: 1rem;\n  text-align: center;\n  min-height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.timer-text {\n  color: var(--text-muted);\n  font-size: 0.95rem;\n  font-weight: 500;\n  margin: 0;\n}\n\n.timer-text span {\n  color: var(--primary);\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  margin-left: 4px;\n}\n\n/* Checkbox */\n.form-checkbox {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n}\n\n.form-checkbox input[type=\"checkbox\"] {\n  margin-top: 0.25rem;\n  width: 20px;\n  height: 20px;\n  accent-color: var(--primary);\n  cursor: pointer;\n  border-radius: 6px;\n}\n\n.form-checkbox label {\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  line-height: 1.5;\n  cursor: pointer;\n}\n\n.form-checkbox a {\n  color: var(--primary);\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.3s ease;\n}\n\n.form-checkbox a:hover {\n  text-decoration: underline;\n  color: var(--primary-dark);\n}\n\n/* Submit Button */\n.submit-btn {\n  background: linear-gradient(135deg, #f7bd20, #f5a623);\n  color: #1a1a1a;\n  border: none;\n  border-radius: 14px;\n  padding: 0.9rem 1.5rem;\n  font-size: 1.05rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 10px 30px rgba(247, 189, 32, 0.3),\n    0 2px 8px rgba(247, 189, 32, 0.15);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.submit-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 15px 40px rgba(247, 189, 32, 0.4),\n    0 5px 15px rgba(247, 189, 32, 0.2);\n}\n\n.submit-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.submit-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(26, 26, 26, 0.3);\n  border-top-color: #1a1a1a;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.change-number-btn {\n  background: transparent;\n  border: 2px solid rgba(247, 189, 32, 0.3);\n  color: var(--primary);\n  border-radius: 14px;\n  padding: 0.9rem 2rem;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.change-number-btn:hover {\n  background: rgba(247, 189, 32, 0.1);\n  border-color: var(--primary);\n  transform: translateY(-1px);\n}\n\n/* Footer */\n.login-footer {\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 0.95rem;\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid rgba(247, 189, 32, 0.1);\n}\n\n.login-footer a {\n  color: var(--primary);\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.3s ease;\n}\n\n.login-footer a:hover {\n  text-decoration: underline;\n  color: var(--primary-dark);\n}\n\n/* Right Section - Visual */\n/* Carousel Styles */\n.login-visual-section {\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  background: #000;\n  padding: 0;\n}\n\n.carousel-track {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.carousel-slide {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n  opacity: 0;\n  transition: opacity 1s ease-in-out;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding: 40px;\n  z-index: 1;\n}\n\n.carousel-slide.active {\n  opacity: 1;\n  z-index: 2;\n}\n\n.slide-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.2) 50%, rgba(0, 0, 0, 0.1) 100%);\n  z-index: -1;\n}\n\n.slide-content {\n  color: #fff;\n  z-index: 3;\n  animation: slideUp 0.8s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.slide-content h2 {\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 12px;\n  line-height: 1.2;\n}\n\n.slide-content p {\n  font-size: 14px;\n  opacity: 0.9;\n  line-height: 1.6;\n  max-width: 80%;\n}\n\n.carousel-indicators {\n  position: absolute;\n  bottom: 30px;\n  right: 30px;\n  display: flex;\n  gap: 8px;\n  z-index: 10;\n}\n\n.indicator {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.indicator.active {\n  background: #fff;\n  width: 30px;\n  border-radius: 10px;\n}\n\n\n/* Responsive */\n@media (max-width: 968px) {\n  .login-container {\n    grid-template-columns: 1fr;\n  }\n\n  .login-visual-section {\n    display: none;\n  }\n\n  .login-logo img {\n    height: 140px;\n  }\n\n  .login-form-section {\n    min-height: auto;\n    padding: 1.5rem 1.75rem;\n  }\n}\n\n@media (max-width: 640px) {\n  .login-page {\n    padding: 1rem;\n  }\n\n  .login-form-section {\n    padding: 2rem 1.5rem;\n  }\n\n  .login-content h1 {\n    font-size: 2rem;\n  }\n\n  .login-tabs {\n    gap: 0.5rem;\n  }\n\n  .tab-btn {\n    padding: 0.75rem 1rem;\n    font-size: 0.9rem;\n  }\n\n  .tab-btn svg {\n    width: 16px;\n    height: 16px;\n  }\n\n  .otp-inputs {\n    gap: 0.5rem;\n  }\n\n  .otp-inputs input {\n    font-size: 1.25rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
